module.exports = __webpack_public_path__ + "UX47.png?fe1773cb2d6858e21ec4af3f9f0cf242";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX47.png
// module id = 98
// module chunks = 0